export enum LogLevel {
  ERROR = 10,
  WARN = 20,
  INFO = 30,
  DEBUG = 40,
}
